module.exports = __webpack_public_path__ + "static/img/thumb_17.bd77d8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_17.jpg
// module id = DtR9
// module chunks = 0